/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import mapKeys from 'lodash/mapKeys'

import { InputText } from 'primereact/inputtext';
import {Checkbox} from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import JustificationModal from '@components/JustificationModal';

import { getDictionaryLanguage, updatetextDictionary, deleteTextDictionary } from '@actions/locale';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'

import './style.scss'

class Dictionary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clave: '',
      name: {},
      dictionary: {},
      fullDictionary: {},
      onlyMissingValues: false,
      find: '',
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
  }

  async componentDidMount () {
    const { history } = this.props
    if (!history.location.state?.data?.clave) return history.push('/languages')
    await this.getDictionary(history.location.state?.data.clave)
    this.setState({
      clave: history.location.state?.data.clave,
      name: history.location.state?.data.nombre,
    })
    return true
  }

  getDictionary = async (clave) => {
    const { getDictionaryLanguage } = this.props
    const response = await getDictionaryLanguage(clave)
    if (!response?.status) {
      this.setState({
        fullDictionary: response.data,
        dictionary: response.data
      })
    }
  }

  onChangeObj = ({target}) => {
    const { dictionary, fullDictionary } = this.state
    dictionary[target.name] = target.value
    fullDictionary[target.name] = target.value
    this.setState({dictionary, fullDictionary})
  }

  onChange = ({target}) => {
    this.setState({[target.name]: target.value})
  }

  onChangeFind = ({target}) => {
    this.setState({[target.name]: target.value}, () => this.filterDirectory())
  }

  filterDirectory = () => {
    const { fullDictionary, onlyMissingValues, find } = this.state
    let filterDictionary = {}
    if (onlyMissingValues) {
      mapKeys(fullDictionary, (value, key) => {
        if(!value) filterDictionary[key] = value
      })
    } else filterDictionary = fullDictionary
    if (find) {
      filterDictionary = Object.keys(filterDictionary).reduce((accum, key) => {
        if (key.toUpperCase().includes(find.toUpperCase())) accum[key] = filterDictionary[key]
        else if ((filterDictionary[key].toUpperCase()).includes(find.toUpperCase())) accum[key] = filterDictionary[key]
        return accum;
      }, {})
    }
    this.setState({dictionary: filterDictionary})
  }

  onUpdateTextDictionary = async ({target}) => {
    const { updatetextDictionary, sendActionToBitacora } = this.props
    const { clave } = this.state
    const data = {
      clave,
      key: target.name,
      value: this.validateValueDictionary(target.value)
    }
    await updatetextDictionary(data)
    const dataBitacora = {
      transactionName: 'actTextosIdioma',
      reason: `${target.name} - ${clave} || ${data.value}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  validateValueDictionary = (value) => {
    const formatValue = value.replace(/"/g, "“")
    return formatValue
  }

  onConfirmDeleteText = (key) => {
    const { dictionary } = this.state
    const { t } = this.props;
    const data = [ key ]
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: dictionary[key] || key}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteText(data, justification),
      }
    });
  }

  onDeleteText = async (data, justification) => {
    const { t, deleteTextDictionary, sendActionToBitacora } = this.props;
    const { clave } = this.state
    const response = await deleteTextDictionary(data);
    if (!response?.status) {
      await this.getDictionary(clave)
      const dataBitacora = {
        transactionName: 'bajaTextosIdioma',
        reason: `${data[0]} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
  };

  render() {
    const { t, isFullAdmin } = this.props;
    const { name, dictionary, onlyMissingValues, find, showModalJustification } = this.state;
    const renderTranslations = Object.keys(dictionary).map((key, index) => (
          <>
            <div className={`p-col-12 p-lg-5 p-md-5 border-bottom-lg-blue ${isFullAdmin ? "p-lg-5 p-md-5" : "p-lg-6 p-md-6"}`}>
              <label className="p-text-bold">{key}</label>
            </div>
            <div className="p-col-12 p-lg-6 p-md-6 border-bottom-blue">
              <InputText
                name={`${key}`}
                value={dictionary[key]}
                onChange={this.onChangeObj}
                className="is-full-width"
                onBlur={this.onUpdateTextDictionary}
              />
            </div>
            { isFullAdmin && (
              <div className='p-col-12 p-lg-1 p-md-1 p-text-center border-bottom-blue'>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  className="p-button-text"
                  style={{ marginRight: '.5em' }}
                  onClick={() => this.onConfirmDeleteText(key)}
                />
              </div>  
            )}
          </>
        ))

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={`${t('Diccionario de ')} ${getValueLanguageObj(name)}`} linkText={t("Ir al listado")} to="/languages"/>
        </div>
        <div className="p-lg-10 p-lx-10 p-sm-12 p-md-12 p-lg-offset-1 p-lx-offset-1 p-sm-offset-0 p-dm-offset-0 p-grid card p-treetable p-component p-pb-5">
          <div className="p-col-12 p-treetable-header p-grid">
            <div className="p-col-12 p-md-8 p-lg-8 p-d-flex p-ai-center">
              <div className="p-col p-d-flex p-ai-center is-full-width">
                <label className="p-mr-2 p-text-bold">{t('Texto o Traducción')}</label>
                <InputText
                  name="find"
                  value={find}
                  onChange={this.onChangeFind}
                  className="p-mr-2 input-search-list is-full-width"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-4 p-lg-4 l p-d-flex p-ai-center is-full-width">
              <Checkbox inputId="cb1" checked={onlyMissingValues} onChange={e => this.setState({ onlyMissingValues: e.checked }, () => this.filterDirectory())} />
              <label htmlFor="cb1" className="p-checkbox-label p-pl-2">{t('Ver solo faltantes')}</label>
            </div>
          </div>
          <div className="p-col-6 border-header-blue">
            <label className="p-text-bold">{t('Texto')}</label>
          </div>
          <div className="p-col-6 border-header-blue">
            <label className="p-text-bold">{t('Traducción')}</label>
          </div>
          { renderTranslations}
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: {isVisible: false}})}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getDictionaryLanguage,
  updatetextDictionary,
  sendActionToBitacora,
  deleteTextDictionary,
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Dictionary);
